import(/* webpackMode: "eager", webpackExports: ["OperationSingle"] */ "/vercel/path0/src/components/single/operation.tsx");
